
export default class MarkCodes
{
    public static readonly AI_SOUND_OF_LONG_A:string = "v";
    public static readonly AR_SOUND_OF_OR:string = "r";
    public static readonly AR_SOUND_OF_AIR:string = "=";
    public static readonly AUDIO_ID_START:string = "‹";
    public static readonly AUDIO_ID_STOP:string = "›";
    public static readonly BLEND_2_LETTER:string = "b";
    public static readonly BLEND_3_LETTER:string = "t";
    public static readonly BLEND_4_LETTER:string = "d";
    public static readonly CONSONANT_Y:string = "<";
    public static readonly COMMAND_BREAK:string = ",";
    //public static readonly DIGRAPH:string = "d";
    public static readonly EA_OR_EI_SOUND_OF_LONG_A:string = "@";
    //public static readonly EA_SOUND_OF_SHORT_E_EA:string = "$";
    public static readonly ER_SOUND_OF_EAR:string = "^";
    public static readonly GUARDIAN:string = "g";
    public static readonly GUARDIAN_2_LETTER:string = "m";
    public static readonly GUARDIAN_3_LETTER:string = "w";
    public static readonly INSTRUCT_START:string = "«";
    public static readonly INSTRUCT_STOP:string = "»";
    public static readonly LONG:string = "l";
    public static readonly OR_SOUND_OF_ER:string = "i";
    public static readonly OW_SOUND_OF_LONG_O:string = "%";
    public static readonly PH_MAKES_SOUND_OF_F:string = "#";
    public static readonly RAINBOW_J:string = "j";
    public static readonly RAINBOW_J_GUARDIAN:string = "jm";
    public static readonly RAINBOW_S:string = "c";
    public static readonly RAINBOW_S_GUARDIAN:string = "cm";
    public static readonly S_SOUND_OF_Z:string = "z";
    public static readonly SCHWA:string = "e";
    public static readonly SCHWA_LE_ENDINGS:string = "u";
    public static readonly SHORT:string = "s";
    public static readonly SILENT_VOWEL:string = "|";
    public static readonly SELECTION_FOR_Y:string = "q";
    public static readonly SLIDE_ARROW:string = ">";
    //public static readonly SOUND_OF_K:string = "+";
    public static readonly SOUND_OF_LONG_A:string = "@";
    //public static readonly SOUND_OF_SH:string = "&";
    public static readonly SOUND_OF_Y_LONG_E:string = "f";
    public static readonly SOUND_OF_Y_LONG_I:string = "k";
    public static readonly SOUND_OF_Y_SHORT_I:string = "n";
    public static readonly SPLIT_BLEND:string = "}";
    public static readonly SYLLABLE_BEGIN:string = "[";
    public static readonly SYLLABLE_END:string = "]";
    public static readonly SYLLABLE_SPLIT:string = "/";
    public static readonly UNDERLINE:string = "o";
    public static readonly VOICED_TH:string = "~";
    public static readonly VOICELESS_TH:string = "-";
    public static readonly VOWEL:string = "x";
    public static readonly VOWEL_2_LETTER:string = "y";
    public static readonly VOWEL_EXCEPTION:string = "p";
    public static readonly VOWEL_EXCEPTION_SHORT_SOUND:string = "h";
    public static readonly VOWEL_SHORT_O_SOUND:string = "a";

    public static DEFAULT:string = MarkCodes.VOWEL

    public static readonly MARKS:string[] = [
        MarkCodes.AI_SOUND_OF_LONG_A,
        MarkCodes.AR_SOUND_OF_OR,
        MarkCodes.AR_SOUND_OF_AIR,
        MarkCodes.BLEND_2_LETTER,
        MarkCodes.BLEND_3_LETTER,
        MarkCodes.BLEND_4_LETTER,
        MarkCodes.CONSONANT_Y,
        MarkCodes.EA_OR_EI_SOUND_OF_LONG_A,
        //MarkCodes.EA_SOUND_OF_SHORT_E_EA,
        MarkCodes.ER_SOUND_OF_EAR,
        MarkCodes.GUARDIAN,
        MarkCodes.GUARDIAN_2_LETTER,
        MarkCodes.GUARDIAN_3_LETTER,
        MarkCodes.LONG,
        MarkCodes.OR_SOUND_OF_ER,
        MarkCodes.OW_SOUND_OF_LONG_O,
        MarkCodes.PH_MAKES_SOUND_OF_F,
        MarkCodes.RAINBOW_J,
        MarkCodes.RAINBOW_J_GUARDIAN,
        MarkCodes.RAINBOW_S,
        MarkCodes.RAINBOW_S_GUARDIAN,
        MarkCodes.S_SOUND_OF_Z,
        MarkCodes.SCHWA,
        MarkCodes.SCHWA_LE_ENDINGS,
        MarkCodes.SHORT,
        MarkCodes.SILENT_VOWEL,
        MarkCodes.SELECTION_FOR_Y,
        MarkCodes.SLIDE_ARROW,
        //MarkCodes.SOUND_OF_K,
        MarkCodes.SOUND_OF_LONG_A,
        //MarkCodes.SOUND_OF_SH,
        MarkCodes.SOUND_OF_Y_LONG_E,
        MarkCodes.SOUND_OF_Y_LONG_I,
        MarkCodes.SOUND_OF_Y_SHORT_I,
        MarkCodes.SPLIT_BLEND,
        MarkCodes.SYLLABLE_BEGIN,
        MarkCodes.SYLLABLE_END,
        MarkCodes.SYLLABLE_SPLIT,
        MarkCodes.UNDERLINE,
        MarkCodes.VOICED_TH,
        MarkCodes.VOICELESS_TH,
        MarkCodes.VOWEL,
        MarkCodes.VOWEL_2_LETTER,
        MarkCodes.VOWEL_EXCEPTION,
        MarkCodes.VOWEL_EXCEPTION_SHORT_SOUND,
        MarkCodes.VOWEL_SHORT_O_SOUND
    ];
}